import React from 'react';
import { Button } from '@lwt-helix/buttons';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { building_modern } from '@lwt-helix/helix-icon/outlined';
import { brandingTerms as bt, uploaderConfig as uc } from '../../../../constants/branding';
import Modal from '@lwt-helix/modal';
import { appLabels, runningApp } from '../../../../constants/app';
import Dropzone from '../../Dropzone';
import { useBranding } from '../../../hooks/branding';
import Loader from '@lwt-helix/loader';
import { ToastContainer } from '@lwt-helix/toast';

export const Branding = () => {
    const {
        uploaderRef,
        state: { shouldShowLogoUploader, shouldShowRemoveLogoModal, shouldShowUpdateLogoModal, isLogoLoading,
            isUploaderLoading, isDeletingLogo, isUpdatingLogo, toastProps },
        setters: { setShouldShowLogoUploader, setShouldShowRemoveLogoModal, setShouldShowUpdateLogoModal },
        handleOnLogoUpload,
        handleRemoveLogo,
        handleConfirmUpdateLogo,
        logoSrc,
    } = useBranding();

    const removeLogoModalContent = (
        <div className="text-center">
            <p>{bt.removeLogoModal.body}</p>
        </div>
    );

    const updateLogoModalContent = (
        <div className="text-center">
            <p>{bt.updateLogoModal.body}</p>
        </div>
    );

    return (
        <div className="d-flex flex-column align-items-center text-center">
            <h6 className="font-weight-bold text-start">
                {bt.profileTabTitle(appLabels[runningApp])}
            </h6>
            <p>{bt.profileTabDescription}</p>
            {!logoSrc ? (
                <HelixIcon
                    className="branding-logo mb-4 p-2 "
                    height={120}
                    width={120}
                    icon={building_modern}
                />
            ) : (
                <div className="mb-4 d-flex align-items-center justify-content-center">
                    {isLogoLoading ? <Loader /> : <img id='branding-logo' src={logoSrc} />}
                </div>
            )}
            <div className="d-flex flex-row">
                <Button onClick={() => setShouldShowLogoUploader(true)}>
                    {logoSrc ? bt.updateLogoButton : bt.addLogoButton}
                </Button>
                {logoSrc && (
                    <Button onClick={() => setShouldShowRemoveLogoModal(true)}>
                        {bt.removeLogoButton}
                    </Button>
                )}
            </div>
            <p className="font-weight-bold mt-4">{bt.profileTabFileTitle}</p>
            <p>{bt.profileTabFileDescription}</p>
            <Modal
                size="sm"
                key={'branding-logo-uploader'}
                title={bt.addLogo}
                show={shouldShowLogoUploader}
                onClose={() => setShouldShowLogoUploader(false)}
                buttons={[]}
            >
                {isUploaderLoading ? (
                    <div className="branding-loader-container">
                        <Loader />
                    </div>
                ) : (
                    <Dropzone
                        dataLwtId={'branding-logo-uploader'}
                        onUpload={handleOnLogoUpload}
                        uppyRef={uploaderRef}
                        autoProceed={false}
                        allowedFileTypes={uc.allowedLogoFileTypes}
                        maxFileSizeInBytes={uc.maxLogoFileSizeInBytes}
                        maxNumberOfFiles={uc.maxNumberOfLogoFiles}
                        autoOpenFileEditor
                        imageEditorOptions={{
                            actions: {
                                cropSquare: false,
                                cropWidescreen: false,
                                cropWidescreenVertical: false
                            },
                        }}
                        plugins={['ImageEditor']}
                    />
                )}
            </Modal>
            <Modal
                size="sm"
                key={'branding-remove-logo-modal'}
                title={bt.removeLogoModal.title}
                show={shouldShowRemoveLogoModal}
                onClose={() => !isDeletingLogo && setShouldShowRemoveLogoModal(false)}
                buttons={
                    <>
                        <Button
                            dataLwtId="cancel-remove-logo"
                            color="secondary"
                            disabled={isDeletingLogo}
                            onClick={() => setShouldShowRemoveLogoModal(false)}
                        >
                            {bt.removeLogoModal.cancelButton}
                        </Button>
                        <Button
                            dataLwtId="confirm-remove-logo"
                            color="primary"
                            disabled={isDeletingLogo}
                            onClick={handleRemoveLogo}
                        >
                            <div className='d-flex justify-content-center align-items-center xs-spinner'>
                                {isDeletingLogo && <Loader />}
                                <p className='pl-2 pr-1 m-0'>{bt.removeLogoModal.confirmButton}</p>
                            </div>
                        </Button>
                    </>
                }
            >
                {removeLogoModalContent}
            </Modal>
            <Modal
                size="sm"
                key={'branding-update-logo-modal'}
                title={bt.updateLogoModal.title}
                show={shouldShowUpdateLogoModal}
                onClose={() => !isUpdatingLogo && setShouldShowUpdateLogoModal(false)}
                buttons={
                    <>
                        <Button
                            dataLwtId="cancel-update-logo"
                            color="secondary"
                            disabled={isUpdatingLogo}
                            onClick={() => setShouldShowUpdateLogoModal(false)}
                        >
                            {bt.updateLogoModal.cancelButton}
                        </Button>
                        <Button
                            dataLwtId="confirm-update-logo"
                            color="primary"
                            disabled={isUpdatingLogo}
                            onClick={handleConfirmUpdateLogo}
                        >
                            <div className='d-flex justify-content-center align-items-center xs-spinner'>
                                {isUpdatingLogo && <Loader />}
                                <p className='pl-2 pr-1 m-0'>{bt.updateLogoModal.confirmButton}</p>
                            </div>
                        </Button>
                    </>
                }
            >
                {updateLogoModalContent}
            </Modal>
            <ToastContainer
                position="toast-bottom-right"
                dataLwtId="branding-logo-toast"
                toastProps={toastProps}
            />
        </div>
    );
};
